import { APICallV3Post } from 'reactApp/api/APICall';

type SubscriptionBuyMidasTrialResponse = { pw: string };

export class SubscriptionBuyMidasTrialAPICall extends APICallV3Post<SubscriptionBuyMidasTrialResponse> {
    _method = 'billing/subscription/trial2';
}
